import React, { createContext, useState } from "react";
import { gql } from "apollo-boost";
import { useApolloClient } from "@apollo/react-hooks";

export const ServerNotificationsContext = createContext();

export const ServerNotificationsProvider = ({ children }) => {
  const [serverNotifications, setServerNotifications] = useState([]);
  const client = useApolloClient();

  const getServerNotifications = ({ priority } = {}) => {
    client
      .query({
        query: NOTIFICATIONS_QUERY,
        variables: {
          ...(priority && { priority })
        },
        fetchPolicy: "network-only"
      })
      .then(x => {
        const {
          data: { notifications: n = [] }
        } = x;
        if (n.length) {
          setServerNotifications(n);
        } else {
          setServerNotifications([]);
        }
      });
  };

  const getNotifications = filterProps => {
    if (!filterProps) return serverNotifications;
    return serverNotifications.filter(notification => {
      const stuffs = Object.entries(filterProps).map(([key, value]) => {
        if (notification[key] === value) return true;
        return false;
      });
      if (stuffs.every(stuff => stuff)) return true;
      return false;
    });
  };
  return (
    <ServerNotificationsContext.Provider
      value={{
        notifications: serverNotifications,
        getNotifications,
        getServerNotifications
      }}
    >
      {children}
    </ServerNotificationsContext.Provider>
  );
};

const NOTIFICATIONS_QUERY = gql`
  query Notifications(
    $priority: Int
    $page: Int = 0
    $perPage: Int = 20
  ) {
    notifications(
      priority: $priority
      page: $page
      perPage: $perPage
    ) {
      uuid
      created_at
      title
      subtitle
      body
      priority
      list {
        name
        value
      }
      link {
        text
        route
      }
      read
      resolved
      dismissed
      deleted
    }
  }
`;
